import {GET_STOCK_TRANSFER_LIST, SAVE_STOCK_TRANSFER, DELETE_STOCK_TRANSFER} from './actionTypes';

const initialState = {
  error: '',
  stockTransferList: [],
  delRefresh: null
};

const stockTransferReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_STOCK_TRANSFER_LIST:
      return {...state, error: '', stockTransferList: action.payload};

    case SAVE_STOCK_TRANSFER:
      return {...state, error: '', delRefresh: new Date()};

    case DELETE_STOCK_TRANSFER:
      return {...state, error: '', delRefresh: new Date()};

    default:
      return state;
  }
};

export default stockTransferReducer;
